import merge from 'classnames';

import { SimpleIconProps } from '../types';

export const IconCollapseArrow = ({ id, className, color = '#2774AE' }: SimpleIconProps) => (
  <svg
    className={merge(className)}
    fill="none"
    height="8"
    id={id}
    role="img"
    viewBox="0 0 14 8"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7L7 0.999999L1 7"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
